import { createContext, useContext } from 'react';
const noop = () => {};
export const ToastContext = createContext({ success: noop, error: noop });
export const useToast = () => useContext(ToastContext);
